export default () => ({
    showFallback: false,
    initialConsent: null,

    init() {
        // Check immediately
        this.checkBlockedScripts();

        // Also check after a short delay to catch Osano's async blocking
        setTimeout(() => {
            this.checkBlockedScripts();
        }, 500);

        // Watch for changes to script type attributes
        const observer = new MutationObserver(() => {
            this.checkBlockedScripts();
        });
        observer.observe(this.$el, {
            attributes: true,
            attributeFilter: ['type'],
            subtree: true
        });

        // Setup Osano listeners
        if (typeof Osano !== 'undefined' && Osano.cm) {
            this.setupOsanoListeners();
        } else {
            // Wait for Osano to initialize if not ready yet
            window.addEventListener('osano-cm-initialized', () => {
                this.setupOsanoListeners();
            });
        }
    },

    setupOsanoListeners() {
        // Capture the initial consent state to compare against later
        try {
            this.initialConsent = JSON.stringify(Osano.cm.getConsent());
            
            Osano.cm.addEventListener("osano-cm-consent-saved", () => {
                this.handleConsentSaved();
            });
        } catch (e) {
            console.warn('Osano fallback: Error setting up listeners', e);
        }
    },

    handleConsentSaved() {
        // Check scripts immediately regardless of reload need
        this.checkBlockedScripts();

        if (typeof Osano === 'undefined' || !Osano.cm) return;

        try {
            const currentConsent = JSON.stringify(Osano.cm.getConsent());
            
            // Only reload if the consent has actually changed from our initial capture
            // This prevents infinite reload loops on page load
            // if (this.initialConsent && currentConsent !== this.initialConsent) {
            //     window.location.reload();
            // }
        } catch (e) {
            console.warn('Osano fallback: Error checking consent change', e);
        }
    },

    checkBlockedScripts() {
        const embedContainer = this.$el;
        // Use querySelectorAll with properly quoted attribute selector
        const blockedScripts = embedContainer.querySelectorAll('script[type="osano/blocked"]');
        
        // Update showFallback based on whether blocked scripts exist
        this.showFallback = blockedScripts.length > 0;
    }
})
